module.exports = {"private":true,"main":"./DropdownTextInput.js"}


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/fields/DropdownTextInput/package.json
// module id = 830
// module chunks = 0 1